import React from 'react';
import { LayoutDashboard, Users, Bell, Radio, BarChart2, FileText, Settings } from 'lucide-react';
import './Sidebar.css';

const navItems = [
  { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { id: 'personnel', label: 'Roaster', icon: Users },
  { id: 'alerts', label: 'Alerts', icon: Bell },
  { id: 'sos', label: 'SOS', icon: Radio },
  //{ id: 'analytics', label: 'Analytics', icon: BarChart2 },
  { id: 'reports', label: 'Reports', icon: FileText },
  { id: 'settings', label: 'Settings', icon: Settings },
];

const Sidebar = ({ active, onChange }) => {
  return (
    <aside className="sidebar">
      <nav className="sidebar-nav">
        {navItems.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            className={`nav-item ${active === id ? 'active' : ''}`}
            onClick={() => onChange(id)}
            title={label}
          >
            <Icon size={20} />
            <span>{label}</span>
          </button>
        ))}
      </nav>
      <div className="sidebar-footer">
        <div className="made-in">
          <span className="made-text">Made in</span>
          <span className="state-name">Andhra Pradesh</span>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
